"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomePanel = void 0;
const IHomePanelWidget_1 = require("../../core/pluginSystem/IHomePanelWidget");
class HomePanel {
    constructor(viewModel) {
        this.viewModel = viewModel;
    }
    get panelName() {
        return "Home";
    }
    get panelId() {
        return "homePanel";
    }
    renderContent(content, metadata) {
        return __awaiter(this, void 0, void 0, function* () {
            content.createHeading("Home!");
            if (this.viewModel.noAudioPresent) {
                content.createElement("div", div => {
                    div.classList.add("admon-warning");
                    div.textContent = "No audio resource found. Please select an audio resource in song properties.";
                });
            }
            this.gridItems = [];
            let addWidgetDiv = content.createElement("div", div => { });
            let select;
            addWidgetDiv.createElement("select", element => {
                select = element;
                for (let supportedPlugin of this.viewModel.loadedPlugins.filter(plugin => plugin.useHomePanelWidget)) {
                    let option = document.createElement("option");
                    option.id = supportedPlugin.pluginName;
                    option.value = supportedPlugin.pluginName;
                    option.text = supportedPlugin.friendlyPluginName;
                    select.options.add(option);
                }
            });
            let widgetGrid;
            let fillZone;
            addWidgetDiv.createElement("div", buttonDiv => {
                buttonDiv.classList.add("btn-group-horizontal");
            })
                .createElementAndAppend("button", element => {
                let btn = element;
                btn.classList.add("btn");
                btn.textContent = "Insert";
                if (select.options.length === 0) {
                    btn.disabled = true;
                }
                btn.addEventListener("click", (evt) => {
                    evt.preventDefault();
                    let widget = this.viewModel.getPluginByName(select.options[select.selectedIndex].value)
                        .getHomePanelWidget();
                    if (widget != null) {
                        let item;
                        switch (widget.widgetSize) {
                            case IHomePanelWidget_1.WidgetSize.Normal:
                                let gridItem = this.addPluginToArea(widgetGrid, widget, "widget-grid-item");
                                this.gridItems.push(gridItem);
                                break;
                            case IHomePanelWidget_1.WidgetSize.Fill:
                                let fillZoneItem = this.addPluginToArea(fillZone, widget, "widget-fill-zone-item");
                                break;
                        }
                        select.options.remove(select.selectedIndex);
                        if (select.options.length === 0) {
                            btn.disabled = true;
                        }
                    }
                });
            })
                .createElementAndAppend("button", element => {
                let button = element;
                button.classList.add("btn");
                button.textContent = "Toggle Grid Layout";
                button.addEventListener("click", (evt) => {
                    evt.preventDefault();
                    if (widgetGrid.element.classList.contains("widget-grid")) {
                        widgetGrid.element.classList.remove("widget-grid");
                        widgetGrid.element.classList.add("widget-grid-half");
                    }
                    else if (widgetGrid.element.classList.contains("widget-grid-half")) {
                        widgetGrid.element.classList.remove("widget-grid-half");
                        widgetGrid.element.classList.add("widget-grid-one");
                    }
                    else if (widgetGrid.element.classList.contains("widget-grid-one")) {
                        widgetGrid.element.classList.remove("widget-grid-one");
                        widgetGrid.element.classList.add("widget-grid");
                    }
                });
            });
            widgetGrid = content.createElement("div", div => {
                div.classList.add("widget-grid");
            });
            fillZone = content.createElement("div", div => {
                div.classList.add("widget-fill-zone");
            });
        });
    }
    redrawGrid(grid) {
        grid.clear();
        for (let gridItem of this.gridItems) {
            this.addPluginToArea(grid, gridItem.gridWidget, "widget-grid-item");
        }
    }
    addPluginToArea(area, widgetComponent, className) {
        let gridItemWidget = area.createElement("div", gridItem => {
            gridItem.classList.add(className);
            gridItem.id = widgetComponent.widgetId;
        });
        widgetComponent.renderWidget(gridItemWidget, this.viewModel.getSongMetadataForPlugin(widgetComponent.basePlugin.pluginName));
        return { gridItem: gridItemWidget, gridWidget: widgetComponent };
    }
}
exports.HomePanel = HomePanel;
//# sourceMappingURL=HomePanel.js.map